<template>
<div class="form">
  <unifiedHeader style="z-index: 999;"></unifiedHeader>
  <div>
    <div class="retreve">
      <div class="header">微信授权登录</div>
      <div class="bottom" style="height: 12rem;">
        <div class="top" v-if="!showBind">授权登录中。。。</div>
        <div v-else>
          <div class="top">绑定手机号</div>
          <el-input class="newMobile" v-model="mobile" placeholder="手机号码"></el-input>
          <div class="verificationModel">
            <el-input class="setVerification" v-model="verification" placeholder></el-input>
            <el-button
              type="primary"
              plain
              @click="getVerifycode"
              :disabled="disabled"
            >{{typeof(verificationText) == 'number'?verificationText + 's后重新发送':verificationText}}</el-button>
          </div>
          <el-button class="Ok" @click="bindMobile" type="warning">绑定手机号</el-button>
        </div>
      </div>
    </div>
  </div>
</div>
</template>
<script>
import { authApi, formApi } from '@/api'
import { mapActions, mapGetters } from 'vuex';
import { USER_SIGNIN, USER_SIGNOUT } from '@/store/auth';
// import sheader from '@/components/common/sheader' // 头部
import unifiedHeader from '@/components/common/unifiedHeader' // 统一头部
import cryptoPhp from '../../libs/common/cryptoPhp' // 加密解密文件
export default {
  data() {
    return {
      code: '',
      state: '',
      openId: '',
      mobile: '',
      userType: 1,
      showBind: false,
      verification: '', // 验证码
      verificationText: '获取验证码', // 验证码内容
      disabled: false
    }
  },
  mounted() {
    this.code = this.$route.query.code || ''
    this.state = this.$route.query.state
    if (this.role.role === '2') {
      this.userType = 2
    } else if (this.role.role === '5' || this.role.role === '4') {
      this.userType = 3
    } else {
      this.userType = 1
    }
    this.getBindState()

  },
  computed: {
    ...mapGetters(['role'])
  },
  methods: {
    ...mapActions([USER_SIGNIN, USER_SIGNOUT]),
    // 获取短信验证码
    getVerifycode() {
      if (this.mobile === '') {
        this.$message.error('您的手机号码不能为空！');
      } else if (!this.mobile.match(/^1[3,4,5,7,8,9]\d{9}$/)) {
        this.$message.error('您的手机号码的格式不正确！');
      } else {
        this.verifycode();
      }
    },
    // 获取短信验证码
    async verifycode() {
      try {
        let params = {
          mobile: this.mobile,
          nonceL: '',
          smsType: 7
        };
        let data = (await formApi.verifycode(params)).data;
        if (data.statusCode === 200) {
          this.disabled = true;
          this.verificationText = 60;
          let this_ = this;
          let verification = setInterval(function() {
            if (this_.verificationText === 0) {
              this_.verificationText = '重新获取验证码';
              this_.disabled = false;
              clearInterval(verification);
            } else {
              this_.verificationText = this_.verificationText - 1;
            }
          }, 1000);
        }
      } catch (err) {
        console.error(err);
      } finally {
      }
    },
    async getBindState() {
      try {
        let url = encodeURI(`${process.env.VUE_APP_ID_URL}/bind/wx`)
        let params = {
          code: this.code,
          state: this.state,
          userType: this.userType,
          loginSource: 2,
          thirdLoginType: 1,
          redirectUri: url
        }
        let data = (await authApi.getBindState(params)).data
        if (data.statusCode === 200) {
          this.openId = data.data.openId
          // 是否是登陆后绑定第三方
          if (!window.localStorage.bindType || window.localStorage.bindType !== 'wx') {
            this.USER_SIGNIN(data.data);
            window.localStorage.openId = data.data.openId
            window.localStorage.bindType = '1'
            // 是否注册技师或商户
            if (window.localStorage.role === '2' || window.localStorage.role === '4' || window.localStorage.role === '5') {
              this.$router.push({
                path: '/worker/workerInfo?userType=' + window.localStorage.role
              });
            } else if (window.localStorage.role === 'guangwang') { // 是否官网登录
              let jrwyToken = cryptoPhp.Encrypt(data.data.jrwyToken)
              let backUrl = cryptoPhp.Decrypt(window.localStorage.backurl) + '?jrwyToken=' + encodeURIComponent(jrwyToken);
              window.location.href = encodeURI(backUrl)
            } else {
              this.$router.push('/check')
            }
          } else {
            this.bindMobile()
          }
        } else {
          // this.showBind = true
        }
      } catch (err) {
        console.error(err)
      } finally {

      }
    },
    async bindMobile() {
      try {
        let params = {}
        if (window.localStorage.bindType === 'wx') {
          params = {
            loginSource: 2,
            userType: 1,
            mobile: JSON.parse(window.localStorage.id_user).mobile,
            openId: this.openId,
            smsType: '',
            thirdLoginType: 1,
            merchantId: 1189, // 商户ID
          }
        } else {
          params = {
            loginSource: 2,
            userType: this.userType,
            mobile: this.mobile,
            openId: this.openId,
            smsType: 7,
            thirdLoginType: 1,
            merchantId: 1189, // 商户ID
          }
        }
        let data = (await authApi.bindMobile(params)).data
        if (data.data.userId) {
          this.USER_SIGNIN(data.data);
          // this.$router.push('/check')
          this.$router.go(-1)
          // window.localStorage.clear('id_user')
        }
      } catch (err) {
        console.error(err)
      } finally {

      }
    }
  },
  components: {
    // sheader
    unifiedHeader
  }
}
</script>
<style scoped>
@import url('../../assets/styles/bind.less');
</style>
